const MOHAVE_ID = "ck-mohave-css";

/** Load Mohave without inline onload handlers (CSP-safe). */
export function loadMohave() {
  if (typeof document === "undefined" || document.getElementById(MOHAVE_ID)) {
    return;
  }
  const link = document.createElement("link");
  link.id = MOHAVE_ID;
  link.rel = "stylesheet";
  link.href =
    "https://fonts.googleapis.com/css2?family=Mohave:wght@400;600&display=swap";
  document.head.appendChild(link);
}
